// src/components/LogoutButton.js
import React, { useState } from "react";
import { Tooltip, IconButton } from "@chakra-ui/react";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";

// F.eks. "dør ut"-ikoner fra react-icons/ri
import { BiLogOut } from "react-icons/bi";
import { CgLogOut } from "react-icons/cg";

const LogoutButton = () => {
  const [hovered, setHovered] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <Tooltip label="Logg ut" aria-label="Logg ut tooltip" openDelay={300}>
    <IconButton
      aria-label="Logg ut"
      variant="ghost"
      fontSize="24px"
      icon={hovered ? <BiLogOut /> : <CgLogOut />}
      onClick={handleLogout}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      _hover={{
        bg: "transparent",
      }}
      _active={{
        bg: "transparent",
      }}
      _focus={{
        boxShadow: "none",
      }}
    />
  </Tooltip>
  );
};

export default LogoutButton;